import { raygun } from '@ynap/clientside-monitoring'

raygun.agent.footerScript()
